var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationMark({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "33px",
    viewBox: "0 0 26 33",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "map-marker") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Style-Guide",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Colors:-Pastels-Copy",
    transform: "translate(-419.000000, -905.000000)",
    fill: "#091DF2",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-chips",
    transform: "translate(159.375000, 600.776541)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M272.293413,305.159375 C279.181885,305.159375 284.696538,310.623192 284.696538,317.5625 C284.696538,320.045674 283.237169,323.186374 280.603117,327.0622 C279.759208,328.303953 278.805036,329.603033 277.73372,330.982548 C277.450668,331.347029 277.19139,331.678146 276.933878,332.003172 L276.67614,332.327177 C275.856669,333.353162 274.981335,334.409228 273.351248,336.361421 C272.800391,337.021128 271.786668,337.021205 271.23571,336.361581 C269.523177,334.311282 268.642103,333.247742 267.782537,332.167402 L267.524502,331.841792 C267.308661,331.568358 267.089102,331.287602 266.853169,330.983843 C265.780184,329.602392 264.824657,328.301479 263.979758,327.057989 C261.348273,323.185072 259.890288,320.045632 259.890288,317.5625 C259.890288,310.623192 265.40494,305.159375 272.293413,305.159375 Z M272.293413,306.5375 C266.214503,306.5375 261.268413,311.336366 261.268413,317.5625 C261.268413,322.394555 268.470494,330.901205 272.293413,335.478125 C272.576592,335.138989 272.878312,334.778292 273.194273,334.399124 L273.678358,333.816906 C277.627879,329.054533 283.318413,321.855154 283.318413,317.5625 C283.318413,311.336366 278.372322,306.5375 272.293413,306.5375 Z M272.293413,312.05 C275.337882,312.05 277.805913,314.51803 277.805913,317.5625 C277.805913,320.60697 275.337882,323.075 272.293413,323.075 C269.248943,323.075 266.780913,320.60697 266.780913,317.5625 C266.780913,314.51803 269.248943,312.05 272.293413,312.05 Z M272.293413,313.428125 C270.01006,313.428125 268.159038,315.279148 268.159038,317.5625 C268.159038,319.845852 270.01006,321.696875 272.293413,321.696875 C274.576765,321.696875 276.427788,319.845852 276.427788,317.5625 C276.427788,315.279148 274.576765,313.428125 272.293413,313.428125 Z",
    id: "map-marker"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationMark);
export default __webpack_public_path__ + "static/media/location-mark.d97659dcfa6b618017af59f6ec0b6860.svg";
export { ForwardRef as ReactComponent };